module.exports = __webpack_public_path__ + "img/float-glass.cc9d4049.jpg";